import { render, staticRenderFns } from "./CockpitEntryInfoItem.vue?vue&type=template&id=341cb9a3&scoped=true&"
import script from "./CockpitEntryInfoItem.vue?vue&type=script&lang=ts&"
export * from "./CockpitEntryInfoItem.vue?vue&type=script&lang=ts&"
import style0 from "./CockpitEntryInfoItem.vue?vue&type=style&index=0&id=341cb9a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341cb9a3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
